"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useEntrance = void 0;
var axios_1 = __importDefault(require("axios"));
var react_1 = require("react");
var react_router_1 = require("react-router");
var query_string_1 = __importDefault(require("query-string"));
var useEntrance = function () {
    var navigate = (0, react_router_1.useNavigate)();
    // getパラメータに招待コード情報が付与されている場合
    var search = (0, react_router_1.useLocation)().search;
    var params = query_string_1.default.parse(search);
    var _a = (0, react_1.useState)(typeof params.code !== "undefined" ? true : false), invideCodeLoading = _a[0], setInviteCodeLoading = _a[1];
    if (typeof params.code !== "undefined") {
        axios_1.default
            .post("/api/auth", { code: params.code })
            .then(function (result) {
            navigate("/procedure", {
                state: {
                    procedure_code: result.data.procedure_code,
                    procedure_url: result.data.procedure_url,
                },
            });
        })
            .catch(function () {
            setInviteCodeLoading(false);
        });
    }
    var initialValues = { code: "" };
    var validateCode = function (value) {
        var error;
        if (!value) {
            error = "招待コード を入力してください";
        }
        return error;
    };
    var onSubmit = function (values, actions) {
        try {
            axios_1.default
                .post("/api/auth", { code: values.code })
                .then(function (result) { return __awaiter(void 0, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    navigate("/procedure", {
                        state: {
                            procedure_code: result.data.procedure_code,
                            procedure_url: result.data.procedure_url,
                        },
                    });
                    return [2 /*return*/];
                });
            }); })
                .catch(function (error) {
                if (error.response.data.error.type === "not_found") {
                    actions.setErrors({
                        code: error.response.data.error.message,
                    });
                }
                else {
                    actions.setErrors({
                        code: "エラーが発生しました。",
                    });
                }
                actions.setSubmitting(false);
                return;
            });
        }
        catch (error) {
            actions.setErrors({
                code: "エラーが発生しました。",
            });
            actions.setSubmitting(false);
            return;
        }
    };
    // 招待コードを持っていないユーザのログイン
    var noInvitationCode = function () {
        localStorage.setItem("token", "guest");
        navigate("/main");
    };
    return {
        invideCodeLoading: invideCodeLoading,
        initialValues: initialValues,
        validateCode: validateCode,
        onSubmit: onSubmit,
        noInvitationCode: noInvitationCode,
    };
};
exports.useEntrance = useEntrance;
